import { useState } from 'react'
import { useResponsive } from 'ahooks'
import { X } from 'lucide-react'
import { useSnapshot } from 'valtio'

import styles from './index.module.less'
import PromptDrawer from './promptDrawer'
import Selection from './selection'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { configState, configAction } from '@/store'

export default () => {
  const [activeName, setActiveName] = useState<string>('selection')
  const responsive = useResponsive()
  const { showPromptModal } = useSnapshot(configState)

  return (
    <>
      <div
        className={`${styles.instructContainer} `}
        style={{ display: showPromptModal ? 'flex' : 'none' }}
      >
        <div className="flex justify-between items-center py-5">
          <div className="text-lg leading-6 font-medium">指令中心</div>
          <div
            className="cursor-pointer h-6 w-6 flex justify-center items-center"
            onClick={() => {
              configAction.changePromptModal(false)
            }}
          >
            <X size={16} strokeWidth={1.5} />
          </div>
        </div>
        <Tabs defaultValue={activeName} onValueChange={setActiveName}>
          <TabsList className="w-full grid grid-cols-2 p-1 rounded-lg h-10 mb-1">
            <TabsTrigger className="h-8" value="selection">
              多模态能力
            </TabsTrigger>
            <TabsTrigger className="h-8" value="scene">
              应用场景
            </TabsTrigger>
          </TabsList>
        </Tabs>
        {activeName === 'selection' && <Selection />}
        {activeName === 'scene' && <PromptDrawer />}
      </div>
      {responsive.lg && (
        <div
          className={`w-[30px] relative bg-transparent ${
            showPromptModal ? 'hidden' : 'flex'
          }`}
        >
          <div
            className="cursor-pointer flex flex-col gap-1 justify-center items-center bg-[#1C1F2308] h-16 w-full absolute top-1/2 -translate-y-1/2 rounded-s-xl text-[#BBBCBD] text-sm font-medium"
            onClick={() => {
              configAction.changePromptModal(true)
            }}
          >
            <span>指</span>
            <span>令</span>
          </div>
        </div>
      )}
    </>
  )
}
